import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Between = ({ property, onChange }) => {
  const PropertyComponent = resolveComponentForOperator(property.type, 'BETWEEN')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default Between
